import type { RouteRecordRaw } from 'vue-router';

export const subcontractingRoutes: RouteRecordRaw[] = [
  {
    path: 'subcontracting/orders',
    name: 'subcontracting-orders',
    component: () => import('../pages/subcontracting/ExternalProcessingOrdersPage.vue'),
    meta: { requiresModule: 'subcontracting' },
  },
];
